import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoInvoiceListEmspUserDidCell } from './emsp-bo-invoice-list-emsp-user-did.cell';
import { EmspBoInvoiceListEmspUserDidHeader } from './emsp-bo-invoice-list-emsp-user-did.header';

export const EmspBoInvoiceListEmspUserDidColumn: IdentifiedColumnDef<
  EmspUserInvoiceBaseModel,
  EmspUserInvoiceBaseModel['emspUser']['did']
> = {
  id: 'emspUserDid',
  enableSorting: false,
  header: EmspBoInvoiceListEmspUserDidHeader,
  cell: EmspBoInvoiceListEmspUserDidCell,
};
